<template>
  <section class="chart-container">
    <el-row :gutter="20">
      <el-col :xs="12" :sm="8" :md="6" :lg="4" v-for="item in navigationList" :key="item.id">
        <el-card shadow="hover" class="nav-card" @click.native="handleNavigationClick(item.id)">
          {{ item.title }}
        </el-card>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import {navigationApi} from '../api/index';
import {HttpResp} from '../constant/index';

export default {
  name: 'home',
  data() {
    return {
      navigationList: [],
    }
  },

  methods: {
    getNavigationList() {
      navigationApi.list().then(response => {
        if (response.code == HttpResp.SUCCUSS) {
          this.navigationList = response.data;
        } else {
          this.$message.error('获取导航列表失败');
        }
      });
    },
    handleNavigationClick(id) {
      navigationApi.getUrl(id).then(response => {
        if (response.code == HttpResp.SUCCUSS && response.data) {
          window.open(response.data, '_blank');
        } else {
          this.$message.error('获取URL失败');
        }
      });
    }
  },
  mounted: function () {
    this.getNavigationList()
  }
}
</script>

<style scoped>
  .chart-container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .nav-card {
    cursor: pointer;
    text-align: center;
  }
  .el-col {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue